import queryString from 'query-string';

export default {
  setUrlParameters(url, parameters, includeQueryString) {
    if (url  && parameters) {
      const queryParams = {};
      for (let key in parameters) {
        let splitUrl = url.split("/");
        let reg = new RegExp(`:${key}$`);
        if (!splitUrl.includes(`:${key}`)) Object.assign(queryParams, { [key]: parameters[key] });
        url = splitUrl.map(x => x.replace(reg, parameters[key])).join("/");
      }
      if (includeQueryString && Object.keys(queryString).length != 0) url += "?" + queryString.stringify(queryParams);
    }
    return url
  },
  //Recebe routerManager.name, Retorna Url "contexto/subcontexto/funcionalidade"
  contextUrl(routerName){
    return routerName.substring(0, routerName.lastIndexOf(".")).replace(/\./g, "/");
  }
}
